import { useState, useEffect } from 'react';

// Component
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';

// Redux & Action
import { useDispatch } from 'react-redux';
import { setSnackbarData } from "@core/redux/actions/app/snackbar";

export default function SnackbarApp({ snackbarData }) {
    const { statusShow, statusAlert, titleAlert, textAlert } = snackbarData;
    const dispatch = useDispatch();
    const [state] = useState({
        vertical: 'top',
        horizontal: 'right',
    });
    const [open, setOpen] = useState(statusShow);
    const { vertical, horizontal } = state;

    const handleClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
        const action = setSnackbarData({
            statusShow: false,
            statusAlert: "",
            titleAlert: "",
            textAlert: ""
        });
        dispatch(action);
    };

    useEffect(() => {
        let timer1 = setTimeout(() => {
            setOpen(false);
        }, 6000);

        return () => {
            const action = setSnackbarData({
                statusShow: false,
                statusAlert: "",
                titleAlert: "",
                textAlert: ""
            });

            dispatch(action);
            clearTimeout(timer1);
        };
    }, [dispatch]);

    return (
        <div style={{ zIndex: "9999 !important" }}>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal} style={{ textAlign: "left", fontSize: "16px", zIndex: "99999" }}>
                <Alert severity={statusAlert} onClose={handleClose}>
                    <AlertTitle style={{ fontSize: "18px" }}>
                        <span className="kanit">
                            {titleAlert}
                        </span>
                    </AlertTitle>
                    <span className="kanit">
                        {textAlert}
                    </span>
                </Alert>
            </Snackbar>
        </div>
    );
}